import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { ClosePopup, OpenPopup } from '@actions/popup';
import ContactForm from '../components/ContactForm/ContactForm';

interface UseContactFormReturn {
  onOpenContactModal: () => void;
}

const useContactForm = (
  infoMessage?: string,
  _userId?: string,
): UseContactFormReturn => {
  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(ClosePopup());
  }, [dispatch]);

  const onOpenContactModal = useCallback(() => {
    dispatch(
      OpenPopup({
        children: <ContactForm onClose={onClose} infoMessage={infoMessage} />,
        onDone: null,
        onCancel: null,
        positiveText: null,
        negativeText: null,
        closable: true,
        style: {
          padding: '40px',
          maxWidth: '500px',
          width: '100%',
          background: 'var(--card) !important',
          borderRadius: '16px',
          '&&>div:first-child': {
            position: 'absolute !important',
          },
          // mobile ≤743px (was Redesign_MediaQueries.mobile)
          '@media (max-width: 743px)': {
            padding: '20px',
            borderRadius: '20px 20px 0px 0px',
            margin: 'auto auto 0px',
            width: '100%',
          },
        },
      }),
    );
  }, [dispatch, onClose, infoMessage]);

  return { onOpenContactModal };
};

export default useContactForm;
